import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AuthContainer from './containers/AuthContainer';
import AppContainer from './containers/AppContainer';
import AdminPage from './containers/AdminPage';
import TimeClockPage from './containers/TimeClockPage';
import OrgManPage from './containers/OrgManPage';
import UserPage from './containers/UserPage';
import Login from './components/Login';
import ResetPasswordContainer from './containers/ResetPasswordContainer';
import ResetContainer from './containers/ResetContainer';
import FormContainer from './containers/FormContainer';

import NotFoundPage from './components/AppLayout/NotFoundPage';

export default (
  <Route path="/" component={AppContainer}>

    <Route path="login" component={Login}/>
    <Route path="reset_password" component={ResetPasswordContainer}/>
    <Route path="reset" component={ResetContainer}/>
    <Route path="form" component={FormContainer}/>

    <Route component={AuthContainer} >
      <IndexRoute component={UserPage}/>
      <Route path="dashboard" component={UserPage}/>
      <Route path="admin" component={AdminPage}/>
      <Route path="timeclock" component={TimeClockPage}/>
      <Route path="orgman" component={OrgManPage}/>
    </Route>

    <Route path="*" component={NotFoundPage}/>
  </Route>
);


// WEBPACK FOOTER //
// ./src/routes.js